import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import useEmployeeDetails from "../hooks/useEmployeeDetails";

export default function ViewLeaves() {
    const { id, employeeToken } = useEmployeeDetails();
    const API_URL = process.env.REACT_APP_BASE_URL;
    const [teamRequests, setTeamRequests] = useState([]);

    const fetchRequests = useCallback(async () => {
        try {
            const res = await axios.post(
                `${API_URL}/get_staff_leave_requests`,
                { emp: id },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${employeeToken}`,
                    },
                }
            );
            if (res.data?.employeeLeaveRequests) {
                setTeamRequests(res.data.employeeLeaveRequests);
            } else {
                toast.info("No leave requests found.");
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error fetching requests.");
        }
    },[id,employeeToken,API_URL])

    useEffect(() => {
        fetchRequests();
    }, [fetchRequests]);

    const getDuration = (start, end) => {
        const startDate = moment(start);
        const endDate = moment(end);
        return endDate.diff(startDate, "days") + 1;
    };


    return (
        <div className="p-2 max-w-2xl mx-auto">
            <ToastContainer />
            {teamRequests.length === 0 ? (
                <p className="text-gray-500 text-center">No leave requests yet.</p>
            ) : (
                <div className="space-y-3">
                    {teamRequests.map((req) => {
                        // const emp = req.emp || {};
                        // const fullName = `${emp.first_name} ${emp.last_name}`;
                        const createdAt = moment(req.created_at).format("DD MMM YY");
                        const fromDate = moment(req.start_date).format("DD MMM");
                        const toDate = moment(req.end_date).format("DD MMM YYYY");
                        const duration = getDuration(req.start_date, req.end_date);
                        const statusColor = {
                            approved: "text-green-600 uppercase",
                            pending: "text-yellow-600 uppercase",
                            rejected: "text-red-600 uppercase",
                        };
                        return (
                            <div
                                key={req._id}
                                className="bg-white shadow-sm rounded-xl border border-gray-200 space-y-1"
                            >
                                <div className="p-3 space-y-1">
                                    {/* Top: Name + Applied On */}
                                    {/* <div className="text-sm font-semibold text-gray-800">
                                            {fullName}
                                        </div> */}
                                    <div className="flex">
                                        <div className="ml-auto text-end text-[10px] text-gray-400 leading-tight">
                                            <p className="font-light">Applied On {createdAt}</p>
                                        </div>
                                    </div>


                                    {/* Leave Type */}
                                    {req.leave_type && (
                                        <div className="text-sm text-gray-700 font-medium">
                                            <span className="text-gray-500">Leave Type: </span>
                                            {req.leave_type
                                                .split('_')
                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                .join(' ')}
                                        </div>
                                    )}


                                    {/* Leave Date */}
                                    <div className="text-sm text-gray-700 font-medium">
                                        <span className="text-gray-500">Leave Date: </span>
                                        {fromDate} - {toDate}
                                    </div>

                                    {/* Duration */}
                                    <div className="text-sm text-gray-700 font-medium">
                                        <span className=" text-gray-500">Duration &nbsp;&nbsp; &nbsp;: </span>
                                        {duration} {duration > 1 ? "days" : "day"}
                                    </div>
                                    <span className="text-sm text-gray-500 font-medium">Status &nbsp; &nbsp; &nbsp; &nbsp; : </span>
                                    <div className={`inline-block text-xs font-semibold rounded ${statusColor[req.status]}`}>
                                        {req.status}
                                    </div>

                                </div>
                            </div>
                        );
                    })}
                </div>
            )
            }
        </div >
    );
}
